// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutContainer_container__VZNEZ"};